export default {
  modalShowing: false,
  modalContent: undefined,
  customerList: {},
  customerUsers: {},
  customerStatistics: {},
  customerUserCount: {},
  loadingCustomerUsers: false,
  selectedCustomer: 0,
  refreshUsers: false,
  refreshRemoteConnections: false,
  loadingRemoteConnections: false,
  remoteConnections: {},
  remoteConnectionsStateChange: false,
  refreshCustomers: false,
  showingCustomerList: true
}
